import classNames from "classnames";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";

import styles from "./progressbar.module.scss";

type Props = { status: 0 | 1 | 2 | 3 };

// TODO define status mapping
const statusMapping = {
  0: 10,
  1: 40,
  2: 70,
  3: 100,
};

export default function Progressbar(props: Props) {
  const t = useTranslations();

  return (
    <div className={styles.progressbarWrapper}>
      <div className={styles.progressbar}>
        <motion.div
          className={styles.progressbarValue}
          initial={{ width: 0 }}
          animate={{ width: `${statusMapping[props.status]}%` }}
          transition={{ duration: 0.6, delay: 0.5 }}
        />
      </div>
      <div className={classNames(styles.dot, styles.dotConfirmed)}></div>
      <div className={classNames(styles.dot, styles.dotPreparation)}></div>
      <div className={classNames(styles.dot, styles.dotShipped)}></div>
      <div className={classNames(styles.dot, styles.dotDelivered)}></div>
      <div className={styles.labelsWrapper}>
        <p className={classNames({ [styles.active]: props.status === 0 })}>{t("generic.order_status.confirmed")}</p>
        <p className={classNames({ [styles.active]: props.status === 1 })}>{t("generic.order_status.preparation")}</p>
        <p className={classNames({ [styles.active]: props.status === 2 })}>{t("generic.order_status.shipped")}</p>
        <p className={classNames({ [styles.active]: props.status === 3 })}>{t("generic.order_status.delivered")}</p>
      </div>
    </div>
  );
}
